(function () {
  "use strict";

  var PRODUCT_ROOT_SELECTOR = "product-component";
  var PRODUCT_FORM_SELECTOR = ".js-product-form";
  var PRODUCT_SELECT_SELECTOR = ".js-product-select";
  var VARIANT_DATA_SELECTOR = ".js-variant-data";
  var VARIANT_GROUP_SELECTOR = ".js-product-variant";
  var VARIANT_OPTION_SELECTOR = ".js-variant-option";
  var VARIANT_IMAGE_SELECTOR = ".js-variant-image";
  var SUBMIT_SELECTOR = ".js-product-form-submit";
  var MINI_CART_SELECTOR = "main-cart";
  var MINI_CART_TRIGGER_SELECTOR = ".js-modal-trigger[data-type='mini-cart']";
  var MINI_CART_COUNT_SELECTOR = ".js-minicart-count";

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function parseVariantData(form) {
    var dataNode = form.querySelector(VARIANT_DATA_SELECTOR);
    if (!dataNode) return [];

    try {
      return JSON.parse(dataNode.textContent || "[]");
    } catch (error) {
      console.error("Unable to parse variant JSON", error);
      return [];
    }
  }

  function getSelectedOptions(form) {
    var selected = [];
    var groups = Array.prototype.slice.call(form.querySelectorAll(VARIANT_GROUP_SELECTOR));

    groups.sort(function (first, second) {
      return Number(first.dataset.index || 0) - Number(second.dataset.index || 0);
    });

    groups.forEach(function (group) {
      var selectedOption = group.querySelector(VARIANT_OPTION_SELECTOR + ".is-selected");
      if (selectedOption && selectedOption.dataset.value) {
        selected.push(selectedOption.dataset.value);
      }
    });

    return selected;
  }

  function findVariantBySelection(variants, selectedOptions, productSelect) {
    if (!variants.length) return null;

    if (selectedOptions.length) {
      var selectedVariant = variants.find(function (variant) {
        for (var index = 0; index < selectedOptions.length; index += 1) {
          if (variant["option" + (index + 1)] !== selectedOptions[index]) {
            return false;
          }
        }
        return true;
      });

      if (selectedVariant) return selectedVariant;
    }

    if (productSelect && productSelect.value) {
      var selectedId = String(productSelect.value);
      return variants.find(function (variant) {
        return String(variant.id) === selectedId;
      }) || null;
    }

    return null;
  }

  function setSubmitButtonState(submitButton, variant) {
    if (!submitButton) return;

    var addText = submitButton.dataset.add || "Add to bag";
    var oosText = submitButton.dataset.oos || "Out of stock";
    var canBuy = Boolean(variant && variant.available);

    submitButton.disabled = !canBuy;
    submitButton.innerHTML = canBuy ? addText : oosText;
  }

  function syncVariantSelection(form, variants, productSelect, submitButton) {
    var selectedOptions = getSelectedOptions(form);
    var selectedVariant = findVariantBySelection(variants, selectedOptions, productSelect);

    if (selectedVariant && productSelect && String(productSelect.value) !== String(selectedVariant.id)) {
      productSelect.value = selectedVariant.id;
    }

    setSubmitButtonState(submitButton, selectedVariant);
    return selectedVariant;
  }

  function matchesSlide(slide, selectedVariant) {
    var slideVariant = normalize(slide.dataset.variant);
    if (!slideVariant) return false;
    if (!selectedVariant) return false;

    var option1 = normalize(selectedVariant.option1);
    var option2 = normalize(selectedVariant.option2);
    var option3 = normalize(selectedVariant.option3);
    var title = normalize(selectedVariant.title);

    return (
      slideVariant === option1 ||
      slideVariant === option2 ||
      slideVariant === option3 ||
      title.indexOf(slideVariant) > -1 ||
      slideVariant.indexOf(option1) > -1
    );
  }

  function syncVariantImages(root, selectedVariant) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(VARIANT_IMAGE_SELECTOR));
    if (!slides.length) return;

    var visibleCount = 0;

    slides.forEach(function (slide) {
      var showSlide = matchesSlide(slide, selectedVariant);
      slide.hidden = !showSlide;
      if (showSlide) visibleCount += 1;
    });

    if (!visibleCount && slides[0]) {
      slides[0].hidden = false;
    }

    window.dispatchEvent(new Event("resize"));
  }

  function getFormProperties(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      if (key.indexOf("properties[") !== 0 || value === "") return;
      var propertyKey = key.replace("properties[", "").replace("]", "");
      properties[propertyKey] = value;
    });

    return properties;
  }

  function buildAddPayload(form, variantId) {
    var formData = new FormData(form);
    var quantity = Number(formData.get("quantity")) || 1;
    var properties = getFormProperties(formData);
    var item = {
      id: Number(variantId),
      quantity: quantity
    };

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return { items: [item] };
  }

  function updateMiniCartCount() {
    var countNode = document.querySelector(MINI_CART_COUNT_SELECTOR);
    if (!countNode) return Promise.resolve();

    return fetch("/cart.js", {
      credentials: "same-origin"
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        countNode.textContent = cart.item_count;
      })
      .catch(function (error) {
        console.warn("Unable to refresh mini-cart count", error);
      });
  }

  function refreshMiniCart() {
    var miniCart = document.querySelector(MINI_CART_SELECTOR);
    var trigger = document.querySelector(MINI_CART_TRIGGER_SELECTOR);

    if (!miniCart || !miniCart.dataset.id) {
      if (trigger) trigger.click();
      return updateMiniCartCount();
    }

    return fetch(window.location.pathname + "?section_id=" + encodeURIComponent(miniCart.dataset.id), {
      credentials: "same-origin"
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var cartMarkup = doc.querySelector(MINI_CART_SELECTOR);
        if (cartMarkup) {
          miniCart.innerHTML = cartMarkup.innerHTML;
        }
      })
      .catch(function (error) {
        console.warn("Unable to refresh mini-cart", error);
      })
      .finally(function () {
        if (trigger) trigger.click();
      })
      .then(updateMiniCartCount);
  }

  function setButtonLoadingState(submitButton, isLoading) {
    if (!submitButton) return;
    if (isLoading) {
      submitButton.disabled = true;
      submitButton.innerHTML = "Adding";
    }
  }

  function initGiftCardAtc() {
    var root = document.querySelector(PRODUCT_ROOT_SELECTOR);
    if (!root) return;

    var form = root.querySelector(PRODUCT_FORM_SELECTOR);
    if (!form || form.dataset.giftCardAtcBound === "true") return;

    form.dataset.giftCardAtcBound = "true";

    var productSelect = form.querySelector(PRODUCT_SELECT_SELECTOR);
    var submitButton = form.querySelector(SUBMIT_SELECTOR);
    var variants = parseVariantData(form);

    if (!productSelect || !submitButton || !variants.length) return;

    var selectedVariant = syncVariantSelection(form, variants, productSelect, submitButton);
    syncVariantImages(root, selectedVariant);

    form.addEventListener("click", function (event) {
      var option = event.target.closest(VARIANT_OPTION_SELECTOR);
      if (!option || !form.contains(option)) return;

      requestAnimationFrame(function () {
        var variant = syncVariantSelection(form, variants, productSelect, submitButton);
        syncVariantImages(root, variant);
      });
    });

    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var variant = syncVariantSelection(form, variants, productSelect, submitButton);
        if (!variant || !variant.available) return;

        setButtonLoadingState(submitButton, true);

        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(buildAddPayload(form, variant.id))
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Gift card add to cart failed with status " + response.status);
            }
            return response.json();
          })
          .then(function () {
            submitButton.innerHTML = "Added";
            return refreshMiniCart();
          })
          .catch(function (error) {
            console.error(error);
          })
          .finally(function () {
            setTimeout(function () {
              var latestVariant = syncVariantSelection(form, variants, productSelect, submitButton);
              syncVariantImages(root, latestVariant);
            }, 1000);
          });
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGiftCardAtc);
  } else {
    initGiftCardAtc();
  }
})();
